import { defineCopy } from "@tami/core/intl";

import { INTERACTIVE_DEMO_COPY_EN_US } from "./en-us/index.copy";
import { INTERACTIVE_DEMO_COPY_ES_ES } from "./es-es/index.copy";

export const INTERACTIVE_DEMO_COPY_PT_BR = {
  exploreOnYourOwn: "Explorar a demo por conta própria",
} as const;

export const INTERACTIVE_DEMO_COPY = defineCopy(INTERACTIVE_DEMO_COPY_PT_BR, {
  "en-US": INTERACTIVE_DEMO_COPY_EN_US,
  "es-ES": INTERACTIVE_DEMO_COPY_ES_ES,
});
